// Expose jQuery to the global object
window.jQuery = window.$ = jQuery;
	
jQuery (function () {

    $ (window).scrollTop (0);

    ////////////////////////////
    // Step 1
    var $step1Wrapper = $ ('#step-1');

    var $step1 = $ ('#discover_step_1');

    var $step1Question      = $step1.find ('.step-question');
    
    var $step1Option1       = $step1.find ('.option-1');
    var $step1Option1Label  = $step1.find ('.option-1 h3');

    var $step1Option2       = $step1.find ('.option-2');
    var $step1Option2Label  = $step1.find ('.option-2 h3');

    ////////////////////////////
    // Step 2
    var $step2Wrapper = $ ('#step-2');

    var $step2 = $ ('#discover_step_2');

    var $step2Question      = $step2.find ('.step-question');
    
    var $step2Option1       = $step2.find ('.option-1');
    var $step2Option1Label  = $step2.find ('.option-1 h3');

    var $step2Option2       = $step2.find ('.option-2');
    var $step2Option2Label  = $step2.find ('.option-2 h3');

    ////////////////////////////
    // Step 3
    var $step3Wrapper = $ ('#step-3');

    var $step3 = $ ('#discover_step_3');

    var $step3Question      = $step3.find ('.step-question');
    
    var $step3Option1       = $step3.find ('.option-1');
    var $step3Option1Label  = $step3.find ('.option-1 h3');

    var $step3Option2       = $step3.find ('.option-2');
    var $step3Option2Label  = $step3.find ('.option-2 h3');
    
    var $matchItem = $ ('#discover__match__item');
    var $matchLink = $ ('#discover__match__link');

    ////////////////////////////
    // Result
    var $resultWrapper = $ ('#match');
    
    ////////////////////////////
    // Buttons
    var $resetButton = $ ('#discover-reset-button');
    var $startButton = $ ('#discover-start-button');
    var $tryButton = $ ('#discover-try-button');
    
    ////////////////////////////
    // JSON
    var matrixPrime = {};
    var matrix = {
        "label": null,
        "question": "When it comes to my morning coffee I...",
        "item": null,
        "options": [{
            "label": "1",
            "question": "I'm a fan of flavors like...",
            "image": "https://cartelroasting.co/wp-content/uploads/2022/09/milk_illustration.svg",
            "heading": "Like to try new things",
            // "description": "Brief description giving further context to the user to make an informed decision.",
            "item": null,
            "options": [{
                "label": "1-1",
                "question": "My weekend plans are to...",
                "image": "https://cartelroasting.co/wp-content/uploads/2022/09/balanced_illustration.svg",
                "heading": "Apple, nuts, caramel, milk chocolate",
                "item": null,
                "options": [{
                    "label": "1-1-1",
                    "question": null,
                    "options": null,
                    "image": "https://cartelroasting.co/wp-content/uploads/2022/09/keep_it_casual_illustration.svg",
                    "heading": "Keep it casual",
                    "item": "Tier 2: Silvia",
                    "product_id": 1271
                },{
                    "label": "1-1-2",
                    "question": null,
                    "image": "https://cartelroasting.co/wp-content/uploads/2022/09/party_like_1999_illustration.svg",
                    "heading": "Party like it's 1999",
                    "options": null,
                    "item": "Tier 3: Papua",
                    "product_id": 1277
                }]
            },{
                "label": "1-2",
                "question": "My favorite seasons are...",
                "image": "https://cartelroasting.co/wp-content/uploads/2022/09/complex_illustration.svg",
                "heading": "Berries, citrus, dried fruit, dark chocolate",
                "item": null,
                "options": [{
                    "label": "1-2-1",
                    "question": null,
                    "image": "https://cartelroasting.co/wp-content/uploads/2022/09/spring_summer_illustration.svg",
                    "heading": "Spring and Summer",
                    "options": null,
                    "item": "Tier 4W: Ngohzi",
                    "product_id": 778
                },{
                    "label": "1-2-2",
                    "question": null,
                    "image": "https://cartelroasting.co/wp-content/uploads/2022/09/autumn_winter_illustration.svg",
                    "heading": "Fall and Winter",
                    "options": null,
                    "item": "Tier 4N: Tatuau",
                    "product_id": 804
                }]
            }]
        },{
            "label": "2",
            "question": "When it comes to roast I prefer...",
            "image": "https://cartelroasting.co/wp-content/uploads/2022/09/black_illustration.svg",
            "heading": "Like my tried and trues",
            // "description": "Brief description giving further context to the user to make an informed decision.",
            "item": null,
            "options": [{
                "label": "2-1",
                "question": "I usually go for a...",
                "image": "https://cartelroasting.co/wp-content/uploads/2022/09/balanced_illustration.svg",
                "heading": "Deeper, bolder flavors",
                "item": null,
                "options": [{
                    "label": "2-1-1",
                    "question": null,
                    "image": "https://cartelroasting.co/wp-content/uploads/2022/09/balanced_illustration.svg",
                    "heading": "Solid, balanced medium roast",
                    "options": null,
                    "item": "Blend Forty Eight",
                    "product_id": 769
                },{
                    "label": "2-1-2",
                    "question": null,
                    "image": "https://cartelroasting.co/wp-content/uploads/2022/09/balanced_illustration.svg",
                    "heading": "Dark roast, plain and simple",
                    "options": null,
                    "item": "Desert City Dark",
                    "product_id": 787
                }]
            },{
                "label": "2-2",
                "question": "I like a lighter roast",
                "image": "https://cartelroasting.co/wp-content/uploads/2022/09/complex_illustration.svg",
                "heading": "I like a lighter roast",
                "item": null,
                "options": [{
                    "label": "2-2-1",
                    "question": null,
                    "image": "https://cartelroasting.co/wp-content/uploads/2022/09/enjoy_relax_illustration.svg",
                    "heading": "I like to sit and enjoy my coffee",
                    "options": null,
                    "item": "Tier 1: Aroma",
                    "product_id": 754
                },{
                    "label": "2-2-2",
                    "question": null,
                    "image": "https://cartelroasting.co/wp-content/uploads/2022/09/on_the_road_illustration.svg",
                    "heading": "I take my coffee on the road with me",
                    "options": null,
                    "item": "Give Back Blend",
                    "product_id": 814
                }]
            }]
        }]
    }
    
    //
    var step1 = 0;
    var step2 = 0;
    var step3 = 0;

    ////////////////////////////
    // Init
    $step1Wrapper.addClass ('hide');
    $step2Wrapper.addClass ('hide');
    $step3Wrapper.addClass ('hide');
    $resultWrapper.addClass ('hide');

    initStep ($step1Question, $step1Option1, $step1Option1Label, $step1Option2, $step1Option2Label, matrix);

    ////////////////////////////
    // Start Quiz
    $startButton.on ('click', function () {
        $step1Wrapper.removeClass ('hide');
    });

    ////////////////////////////
    // Step 1 actions
    $step1Option1.on ('click', function () {

        // Reset options
        $step1Wrapper.find ('.selected').removeClass ('selected');

        // Reset steps
        resetStep ($step2Wrapper);
        resetStep ($step3Wrapper);
        resetStep ($resultWrapper);
        
        // Select option
        $ (this).addClass ('selected');

        step1 = 0;

        // Update working matrix
        // matrixPrime = matrix.options [0];

        // Init next step
        initStep ($step2Question, $step2Option1, $step2Option1Label, $step2Option2, $step2Option2Label, matrix.options [step1]);

        // Unhide step 2
        $step2Wrapper.removeClass ('hide');
    });

    $step1Option2.on ('click', function () {
        
        // Reset step options
        $step1Wrapper.find ('.selected').removeClass ('selected');

        // Reset steps
        resetStep ($step2Wrapper);
        resetStep ($step3Wrapper);
        resetStep ($resultWrapper);

        // Select option
        $ (this).addClass ('selected');

        step1 = 1;

        // Update working matrix
        // matrixPrime = matrix.options [1];
        
        // Init next step
        initStep ($step2Question, $step2Option1, $step2Option1Label, $step2Option2, $step2Option2Label, matrix.options [step1]);

        // Unhide step 2
        $step2Wrapper.removeClass ('hide');
    });

    ////////////////////////////
    // Step 2 actions
    $step2Option1.on ('click', function () {
        
        // Reset step options
        $step2Wrapper.find ('.selected').removeClass ('selected');

        // Reset steps
        resetStep ($step3Wrapper);
        resetStep ($resultWrapper);
        
        // Select options
        $ (this).addClass ('selected');

        step2 = 0;

        // Update working matrix
        // matrixPrime = matrixPrime.options [0];

        // Init next step
        initStep ($step3Question, $step3Option1, $step3Option1Label, $step3Option2, $step3Option2Label, matrix.options [step1].options [step2]);

        // $step3Option1.attr ('data-product', matrixPrime.options [0].item);
        // $step3Option2.attr ('data-product', matrixPrime.options [1].item);

        // Unhide step 3
        $step3Wrapper.removeClass ('hide');
    });

    $step2Option2.on ('click', function () {
        
        // Reset step options
        $step2Wrapper.find ('.selected').removeClass ('selected');

        // Reset steps
        resetStep ($step3Wrapper);
        resetStep ($resultWrapper);

        // Select options
        $ (this).addClass ('selected');

        step2 = 1;

        // Update working matrix
        // matrixPrime = matrix.options [step1].options [step2];

        // Init next step
        initStep ($step3Question, $step3Option1, $step3Option1Label, $step3Option2, $step3Option2Label, matrix.options [step1].options [step2]);

        // $step3Option1.attr ('data-product', matrixPrime.options [0].item);
        // $step3Option2.attr ('data-product', matrixPrime.options [1].item);

        // Unhide step 3
        $step3Wrapper.removeClass ('hide');
    });

    ////////////////////////////
    // Step 3 actions
    $step3Option1.on ('click', function () {

        // Reset step options
        $step3Wrapper.find ('.selected').removeClass ('selected');
        
        // Select option
        $ (this).addClass ('selected');

        step3 = 0;

        // Show matched product
        showMatch (matrix.options [step1].options [step2].options [step3].label);

        // Show result step
        $resultWrapper.removeClass ('hide');
    });

    $step3Option2.on ('click', function () {

        // Reset step options
        $step3Wrapper.find ('.selected').removeClass ('selected');
        
        // Select option
        $ (this).addClass ('selected');

        step3 = 1;

        // Show matched product
        showMatch (matrix.options [step1].options [step2].options [step3].label);

        // Show result step
        $resultWrapper.removeClass ('hide');
    });


    function resetStep ($step) {
        $step.find ('.selected').removeClass ('selected');
        $step.find ('.discover-result').removeClass ('show');
        $step.addClass ('hide');
    }

    function initStep ($question, $option1, $option1Label, $option2, $option2Label, matrix) {

        $question.text (matrix.question);

        $option1.find ('.discover-step__option-image').attr ('src', matrix.options [0].image);
        $option1Label.text (matrix.options [0].heading);

        $option2.find ('.discover-step__option-image').attr ('src', matrix.options [1].image);
        $option2Label.text (matrix.options [1].heading);
    }

    function showMatch (path) {

        $ ('.discover-result.show').removeClass ('show');
        $ ('.discover-result[data-path=' + path + ']').addClass ('show');

        var productLink = $ ('.discover-result.show').find ('.product-card__upper a:last-child').attr ('href');
        
        $tryButton.attr ('href', productLink);
    }

    ////////////////////////////////////////
    // Reset
    $resetButton.on ('click', function () {
        // matrixPrime = matrix;

        $ ('.selected').removeClass ('selected');
        $ ('.show').removeClass ('show');
        
        $step2Wrapper.addClass ('hide');
        $step3Wrapper.addClass ('hide');
        $resultWrapper.addClass ('hide');
    });
});